/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};
export const AttritionsOverviewReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.ATTRITIONS_OVERVIEW + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.ATTRITIONS_OVERVIEW + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.ATTRITIONS_OVERVIEW + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.ATTRITIONS_OVERVIEW + '_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
        status: action.status
      }
    default:
      return state;
  }
};
